import script from "./PaginatedTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginatedTable.vue?vue&type=script&setup=true&lang=ts"

import "./PaginatedTable.vue?vue&type=style&index=0&id=bd4e0192&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd4e0192"]])

export default __exports__